import "@rmlibrary/fetch";
import "./accordion";

import {
    calculateNumberOfMonthsPerPeriod,
    getBullsAndBearsDataset,
    getBullsAndBearsGraphCss,
    getBullsAndBearsGraphOptions,
    getBullsAndBearsPointsAndWidths
} from "./graphing";

import $ from "jquery";
import { drawGraph } from "@rmlibrary/graph";
import { filterObjectByKeys, getLanguage } from "./utilities";

let bullsAndBearsData = null;

$(() => {
    getBullsAndBearsData().then((bullsAndBearsData) => {
        const organizedBullsAndBearsData = organizeBullsAndBearsData(bullsAndBearsData);
        setupGraphResizing(organizedBullsAndBearsData);
        setTimeout(() => setUpGraph(organizedBullsAndBearsData), 200);
    });

    scrollNav();
    unhideIcon();

    window.onresize = () => {
        scrollNav();
    };
});

function scrollNav() {
    const nav = $("#pgNav");
    const width = nav.width() + 500;
    nav.scrollLeft(width);
}

function unhideIcon() {
    $("#pgNavTaggle").on("click", () => {
        $(".fa-chevron-up").css("display", "");
    });
}

function getBullsAndBearsData() {
    if (bullsAndBearsData) {
        return Promise.resolve(bullsAndBearsData);
    }

    return fetch("./common/data/data.json")
        .then((response) => response.json())
        .then((json) => {
            bullsAndBearsData = json.data;
            return bullsAndBearsData;
        });
}

function organizeBullsAndBearsData(bullsAndBearsData) {
    return (organizedData = bullsAndBearsData.map((data) => {
        const numberOfMonths = calculateNumberOfMonthsPerPeriod(data.startDate, data.closingDate) + 1;
        const startYear = new Date(data.startDate).getFullYear();

        return {
            startYear,
            numberOfMonths,
            percentValue: data.closingPercent
        };
    }));
}

function setUpGraph(bullsAndBearsData) {
    const graphCanvas = document.getElementById("bulls-and-bears-graph");
    const graphTable = document.getElementById("bulls-and-bears-table");

    function drawTable() {
        const table = document.createElement("table");
        table.setAttribute("id", "bulls-and-bears-table-content");
        let tr = undefined;
        let th = undefined;
        let td = undefined;

        const dataArray = [];
        const tableHeaders =
            getLanguage() === "en"
                ? ["Start year", "Bull or bear market", "Length of period", "Change value"]
                : [
                      "Année de début",
                      "Marché haussier ou marché baissier",
                      "Durée de la période",
                      "Changement de valeur"
                  ];
        dataArray.push(tableHeaders);
        for (let i = 0; i < bullsAndBearsData.length; i++) {
            const periodData = [];
            periodData.push(bullsAndBearsData[i].startYear);
            periodData.push(
                bullsAndBearsData[i].percentValue > 0
                    ? getLanguage() === "en"
                        ? "Bull"
                        : "Haussier"
                    : getLanguage() === "en"
                    ? "Bear"
                    : "Baissier"
            );
            periodData.push(`${bullsAndBearsData[i].numberOfMonths} ${getLanguage() === "en" ? "months" : "mois"}`);
            periodData.push(
                `${(bullsAndBearsData[i].percentValue * 100).toFixed()}${getLanguage() === "en" ? "%" : " %"}`
            );
            dataArray.push(periodData);
        }

        for (let i = 0; i < dataArray.length; i++) {
            tr = document.createElement("tr");
            if (i == 0) {
                for (let j = 0; j < dataArray[i].length; j++) {
                    th = document.createElement("th");
                    th.setAttribute("scope", "col");
                    th.appendChild(document.createTextNode(dataArray[i][j]));
                    tr.appendChild(th);
                }
            } else {
                for (let j = 0; j < dataArray[i].length; j++) {
                    td = document.createElement("td");
                    td.appendChild(document.createTextNode(dataArray[i][j]));
                    tr.appendChild(td);
                }
            }
            table.appendChild(tr);
        }
        graphTable.appendChild(table);
    }

    const pointsAndWidths = getBullsAndBearsPointsAndWidths(bullsAndBearsData);
    const css = getBullsAndBearsGraphCss();
    const options = getBullsAndBearsGraphOptions(bullsAndBearsData, pointsAndWidths);
    const dataset = getBullsAndBearsDataset(bullsAndBearsData, pointsAndWidths);

    const ctx = graphCanvas.getContext("2d");

    ctx.clearRect(0, 0, graphCanvas.width, graphCanvas.height);
    drawGraph(graphCanvas, options, css, dataset);

    if (graphCanvas.graphEvents && graphCanvas.graphEvents.mouseleaveEvent) {
        graphCanvas.removeEventListener("mouseleave", graphCanvas.graphEvents.mouseleaveEvent);
        document.removeEventListener("touchend", graphCanvas.graphEvents.mouseleaveEvent);
        graphCanvas.graphEvents = filterObjectByKeys(graphCanvas.graphEvents, ["mouseleaveEvent"]);
    }
    // drawTable({ accessibilityTableDiv, assetMix, options, slices });
    drawTable();
}

function setupGraphResizing(bullsAndBearsData) {
    let containerWidth = $(".card-content").width();
    setSizeOfCanvas(containerWidth);

    $(window).on("resize", () => {
        $("#graph-hover-overlay, #graph-popup").hide();
        setSizeOfCanvas($(".card-content").width());
        setUpGraph(bullsAndBearsData);
    });
}

function setSizeOfCanvas(width) {
    const graphCanvas = document.getElementById("bulls-and-bears-graph");
    graphCanvas.width =
        width * devicePixelRatio * ($(window).outerWidth() <= 545 ? 2.5 : $(window).outerWidth() <= 767 ? 1.5 : 1);
    graphCanvas.height =
        width *
        0.6 *
        devicePixelRatio *
        ($(window).outerWidth() <= 545 ? 2.5 : $(window).outerWidth() <= 767 ? 1.5 : 1);

    graphCanvas.style.width = $(window).outerWidth() <= 545 ? "250%" : $(window).outerWidth() <= 767 ? "150%" : "100%";
}
